import React from "react";
import PropTypes from "prop-types";

import { isEmptyObject } from "@helpers/utils";

import { Modal as MuiModal, Box, TextField, Typography } from "@mui/material";

// import Button from "@components/Button/Button";
import ModalContentBox from "@mui-theme/styled/ModalContentBox";
import CloseModalBox from "@mui-theme/styled/CloseModalBox";
import ThemedButton from "@mui-theme/styled/ThemedButton";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

import useEditEventModal from "./useEditEventModal";

const EditEventModal = props => {
  const {
    open,
    toggle,
    eventTypes,
    state,
    canSubmitForm,
    handleInputChange,
    handleDateChange,
    handleSubmit
  } = useEditEventModal(props);

  const {
    type,
    title,
    startTime,
    endTime,
    description,
    fetching,
    inputErrors,
    serverMessage
  } = state;

  return (
    <MuiModal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          toggle();
        }
      }}
      sx={{
        overflow: "scroll"
      }}
    >
      <ModalContentBox
        sx={{
          maxHeight: "96%"
        }}
      >
        <Box
          sx={{
            width: "100%",
            justifyContent: "flex-start"
          }}
        >
          <Box
            sx={{
              width: "100%",
              px: 2,
              alignItems: "flex-start"
            }}
          >
            <Typography variant="h4" color="common.black">
              Redigera anteckning
            </Typography>
          </Box>
          <Box
            component="form"
            noValidate
            sx={{
              width: "100%",
              alignItems: "flex-start",
              display: "flex",
              flexFlow: "column",
              px: 2
            }}
          >
            <Box
              sx={{
                width: "100%",
                flexDirection: "row",
                alignItems: "flex-start",
                justifyContent: "space-between",
                my: 1
              }}
            >
              <FormControl
                sx={{
                  width: { xs: "100%", md: "25%" },
                  mr: { xs: 0, md: 1 }
                }}
              >
                <InputLabel
                  id="event-type-select-label"
                  htmlFor="type"
                  size="small"
                >
                  Typ
                </InputLabel>
                <Select
                  // size="small"
                  labelId="event-type-select-label"
                  id="type"
                  name="type"
                  value={type}
                  label="Type"
                  onChange={e => {
                    handleInputChange(e);
                  }}
                  MenuProps={{
                    MenuListProps: {
                      style: {
                        width: "100%",
                        textAlign: "left"
                      }
                    }
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    textAlign: "left"
                  }}
                >
                  {eventTypes.map(
                    type =>
                      type && (
                        <MenuItem
                          key={type.key}
                          value={type.key}
                          sx={{ alignItems: "flex-start" }}
                        >
                          {type.label}
                        </MenuItem>
                      )
                  )}
                </Select>
              </FormControl>
              <FormControl
                sx={{
                  width: { xs: "100%", md: "37.5%" },
                  mr: { xs: 0, md: 1 }
                }}
              >
                <DateTimePicker
                  label="Starttid"
                  ampm={false}
                  format="YYYY-MM-DD HH:mm"
                  // viewRenderers={{
                  //   hours: renderTimeViewClock,
                  //   minutes: renderTimeViewClock,
                  //   seconds: renderTimeViewClock
                  // }}
                  value={startTime}
                  onChange={newTime => handleDateChange(newTime, "start")}
                />
              </FormControl>
              <FormControl
                sx={{
                  width: { xs: "100%", md: "37.5%" }
                }}
              >
                <DateTimePicker
                  label="Sluttid"
                  ampm={false}
                  format="YYYY-MM-DD HH:mm"
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock
                  }}
                  minDateTime={startTime}
                  value={endTime}
                  onChange={newTime => handleDateChange(newTime, "end")}
                />
              </FormControl>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                mt: 1
              }}
            >
              <FormControl
                sx={{
                  width: { xs: "100%", md: 405 },
                  mr: { xs: 0, md: 1 }
                }}
              >
                {/* <InputLabel id="event-title-select-label" size="small">
                  Title
                </InputLabel> */}
                <TextField
                  value={title || ""}
                  placeholder={title?.length < 1 ? "Titel" : ""}
                  required
                  fullWidth
                  id="title"
                  name="title"
                  // label="Title"
                  autoComplete="title"
                  error={!!inputErrors?.title}
                  onChange={e => {
                    handleInputChange(e);
                  }}
                  helperText={inputErrors?.title}
                  sx={{
                    mb: 2
                  }}
                />
              </FormControl>
              <TextField
                value={description || ""}
                placeholder={description?.length < 1 ? "Beskriv händelsen" : ""}
                required
                fullWidth
                multiline
                rows={6}
                // maxRows={10}
                id="description"
                name="description"
                autoComplete="description"
                error={!!inputErrors?.description}
                onChange={e => {
                  handleInputChange(e);
                }}
                helperText={inputErrors?.description}
                sx={{
                  mb: 2
                }}
              />
            </Box>
          </Box>
        </Box>
        <CloseModalBox
          sx={{
            px: 2
          }}
        >
          <ThemedButton
            variant="outlined"
            onClick={toggle}
            sx={{
              minWidth: "unset",
              width: 100
            }}
          >
            Avbryt
          </ThemedButton>
          <ThemedButton
            variant="contained"
            loading={fetching}
            disabled={
              !canSubmitForm || (inputErrors && !isEmptyObject(inputErrors))
            }
            onClick={handleSubmit}
            sx={{
              minWidth: "unset",
              width: 150
            }}
          >
            Spara ändringar
          </ThemedButton>
        </CloseModalBox>
      </ModalContentBox>
    </MuiModal>
  );
};

EditEventModal.propTypes = {
  open: PropTypes.bool
};

export default EditEventModal;
